import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import "./i18n";
import App from "./App.jsx";
import { ChatStateProvider } from "./context/ChatStateContext.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router>
      <ChatStateProvider>
        <App />
      </ChatStateProvider>
    </Router>
  </React.StrictMode>,
);
